<script>
import { layoutMethods, erpUserRolesMethods  } from "@/state/helpers";
import ApiService from "@/helpers/api.service";
import {
  required
} from "vuelidate/lib/validators";
import { getModuleAccess } from '@/router/helper.js'

const API = new ApiService();
const totalShareValidatorC = (_, vm) => {
  console.log("totalShareValidatorC: ", vm)
  return parseFloat(vm.userShare) + parseFloat(vm.peddlrShare) === parseFloat(vm.providerShared)
}
const totalShareValidatorUP = (providerShared) => (_,vm) => {
  console.log("providerShared: ", providerShared)
  console.log("vm: ", vm)

  return parseFloat(vm.userShare) + parseFloat(vm.peddlrShare) === parseFloat(providerShared)
}
/**
 * Eload profit sharing component
 */
export default {
  page: {
    title: "Eload Profit Sharing"
  },
  data() {
    return {
      dataList: [],
      title: "Eload Profit Sharing",
      isFetching: false,
      items: [
        {
          text: "Peddlr",
        },
        {
          text: "Eload Profit Sharing",
          active: true,
        },
      ],
      series: [76],
      chartOptions: {
        chart: {
          height: 150,
          type: "radialBar",
          sparkline: {
            enabled: true,
          },
        },
        colors: ["#E73092"],
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#e7e7e7",
              strokeWidth: "97%",
              margin: 5, // margin is in pixels
            },
            hollow: {
              size: "55%",
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: -2,
                fontSize: "21px",
                fontWeight: "bold",
                // color: '#E73092'
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        labels: ["Storage"],
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 6,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "value",
      sortDesc: false,
      fields: [
        {
          key: "action",
          sortable: true,
        },
        {
          key: "provider",
          sortable: true,
        },
        {
          key: "amount",
          sortable: true,
          thClass: "text-end",
        },
        {
          key: "provider_shared",
          sortable: true,
          thClass: "text-end",
        },
        {
          key: "customer_share",
          sortable: true,
          thClass: "text-end",
        },
        {
          key: "peddlr_share",
          sortable: true,
          thClass: "text-end",
        },
        {
          key: "date",
          sortable: true,
        },
      ],
      creationParams: {
        providerName: "",
        amount: "",
        providerShared: "",
        userShare: "",
        peddlrShare: "",
        totalShare:0
      },
      updateParams: {
        userShare: "",
        peddlrShare: "",
        id: 0,
      },
      view: {
        providerName: "",
        amount: "",
        providerShared: "",
        userShare: "",
        peddlrShare: "",
        date: "",
      },
      submit: false,
      updateSubmit: false,
      profitSharingModule: {
				access: {
					create: false,
          update: false
				}
			}
    };
  },
  validations() {
    return {
      creationParams: { 
        providerName: {required},
        amount: {required},
        providerShared: {required},
        userShare: {
          required,
          totalShareValidatorC
        },
        peddlrShare: {
          required,
          totalShareValidatorC
        }
      },
      updateParams: {
        id: {required},
        userShare: {
          required,
          totalShareValidatorU: totalShareValidatorUP(this.view.providerShared)
        },
        peddlrShare: {
          required,
          totalShareValidatorU: totalShareValidatorUP(this.view.providerShared)
        },
      }
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.dataList.length;
    },
    profitSharingList: {
      get() {
        return JSON.parse(JSON.stringify(this.dataList));
      },
    },
    totalShareValidatorC() {
      return isNaN(parseFloat(this.creationParams.peddlrShare) + parseFloat(this.creationParams.userShare)) ? 0 : parseFloat(this.creationParams.peddlrShare) + parseFloat(this.creationParams.userShare)
    },
    totalShareValidatorU() {
      return isNaN(parseFloat(this.updateParams.peddlrShare) + parseFloat(this.updateParams.userShare)) ? 0 : parseFloat(this.updateParams.peddlrShare) + parseFloat(this.updateParams.userShare)
    }
  },
  async mounted() {
    this.getList();
    this.changeTitle({title: 'Eload Profit Sharing'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'Eload Profit Sharing', to: { name: 'Eload Sharing'} }
      ]
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Settings', 'Profit Sharing')
    .then((access) => this.profitSharingModule.access = access);

  },
  methods: {
    ...layoutMethods,
    ...erpUserRolesMethods,
    async getList() {
      let pageInfo = Object;
      await API.post("/profit-sharing/eload/list", {
        page: this.currentPage,
        rows: this.perPage,
      })
        .then((response) => {
          let res = response.data.message;
          this.dataList = res.rows;
          pageInfo = response.data.message.pageInfo;
          console.log(this.dataList);
          this.totalRows = pageInfo.total;
          return;
        })
        .catch(function(error) {
          console.log(error);
          return;
        });
    },
    infoModalFunction(index) {
      this.actionIndex = index;
      this.view.providerName = this.dataList[this.actionIndex].provider;
      this.view.providerShared = this.dataList[
        this.actionIndex
      ].provider_shared;
      this.view.userShare = this.dataList[this.actionIndex].customer_share;
      this.view.peddlrShare = this.dataList[this.actionIndex].peddlr_share;
      this.view.amount = this.dataList[this.actionIndex].amount;
      this.view.date = this.dataList[this.actionIndex].created_at;

      this.updateParams.userShare = this.view.userShare;
      this.updateParams.peddlrShare = this.view.peddlrShare;
      this.updateParams.id = this.dataList[this.actionIndex].id;
    },
    getDate(stirng) {
      let dateOptions = {
        day: "numeric", // numeric, 2-digit
        year: "numeric", // numeric, 2-digit
        month: "long", // numeric, 2-digit, long, short, narrow
        hour: "2-digit", // numeric, 2-digit
        minute: "2-digit", // numeric, 2-digit
      };
      let date = new Date(stirng);

      console.log(date.toLocaleDateString("en-US", dateOptions));
      return date.toLocaleDateString("en-US", dateOptions);
    },
    create() {
      this.submit = true;
      // stop here if form is invalid
      this.$v.$touch();
      console.log("vuelidators: ", this.$v.creationParams)
      if (!this.$v.creationParams.$invalid) {
        this.$bvModal.hide('bv-modal-add-provider-view')
        API.post("/profit-sharing/eload/create", {
          providerName: this.creationParams.providerName,
          amount: parseFloat(this.creationParams.amount),
          providerShared: parseFloat(this.creationParams.providerShared),
          userShare: parseFloat(this.creationParams.userShare),
          peddlrShare: parseFloat(this.creationParams.peddlrShare),

        })
        .then((response) => {
          if (response.data.status == "ok") {
            this.$alertify.success("Created Successfully");
          } else {
            this.$alertify.error(
              "An error occured while trying to create a record."
            );
          }
          this.getList()
          this.onCloseModal()
          return;
        })
        .catch(function (error) {
          this.onCloseModal()
          console.log(error);
          return;
        });
      }

    },
    update() {
      this.updateSubmit = true;
      // stop here if form is invalid
      this.$v.$touch();
      console.log("vuelidators: ", this.$v.updateParams)
      if (!this.$v.updateParams.$invalid) {
        this.$bvModal.hide('bv-modal-edit-provider-view')
        API.post("/profit-sharing/eload/update", {
          userShare: parseFloat(this.updateParams.userShare),
          peddlrShare: parseFloat(this.updateParams.peddlrShare),
          ...this.updateParams,
        })
          .then((response) => {
            if (response.data.status == "ok") {
              this.$alertify.success("Updated Successfully");
            } else {
              this.$alertify.error(
                "An error occured while trying to update the record."
              );
            }
            this.getList();
            return;
          })
          .catch(function(error) {
            console.log(error);
            return;
          });
      }

    },
    onCloseModal() {
      this.$v.$reset();
      this.creationParams = {
        providerName: "",
        amount: "",
        providerShared: "0",
        userShare: "0",
        peddlrShare: "",
      };
      this.updateParams = {
        userShare: "",
        peddlrShare: "",
        id: 0,
      };
    },
    async onNextPage() {
      let pageInfo = Object;
      await API.post("/profit-sharing/eload/list", {
        page: this.currentPage,
        rows: this.perPage,
      })
        .then((response) => {
          let res = response.data.message;
          this.dataList = res.rows;
          pageInfo = response.data.message.pageInfo;
          console.log(this.dataList);
          this.totalRows = pageInfo.total;
          return;
        })
        .catch(function(error) {
          console.log(error);
          return;
        });
    },
    totalShare(event) {
      let data = event.data
      if (data > 0) {
        this.creationParams.totalShare = parseFloat(this.creationParams.userShare) + parseFloat(this.creationParams.peddlrShare)
      } else {
        this.creationParams.totalShare = 0
      }
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-0">
          <div class="card-body pb-4 p-0">
            <div class="row p-4 pt-3 pb-0">
              <div class="col-lg-8">
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <div class="text-center">
                      <apexchart
                        id="radial-chart"
                        class="apex-charts"
                        height="180"
                        width="140"
                        dir="ltr"
                        :series="series"
                        :options="chartOptions"
                      ></apexchart>
                    </div>
                  </div>
                  <div class="flex-grow-1 pt-4 ms-3">
                    <div>
                      <h2 class="mb-1 text-dark">
                        <i class="bx bx-gas-pump text-secondary bx-fw bx-sm"></i
                        >3,800.00
                      </h2>
                      <!-- <p class="mb-0">
                          Neque porro quisquam est, quia dolor sit amet
                        </p> -->
                      <p class="text-muted">3,800.00 (76%) of 5,000.00 used</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->

              <div class="col-lg-4 mt-2 mb-2 my-lg-0">
                <div class="d-flex mt-lg-4 mt-0 justify-content-lg-end">
                  <div class="d-flex align-items-center me-4">
                    <div class="flex-shrink-0 me-3">
                      <i
                        class="uil uil-calendar-alt text-success font-size-22"
                      ></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-12 mb-1">Start Date</h5>
                      <p class="text-muted mb-0">06 Mar, 2021</p>
                    </div>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-3">
                      <i
                        class="uil uil-check-circle text-danger font-size-22"
                      ></i>
                    </div>
                    <div class="flex-grow-1">
                      <h5 class="font-size-12 mb-1">Due Date</h5>
                      <p class="text-muted mb-0">15 May, 2021</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <hr />
            <!-- end row -->
          </div>

          <!-- end card body -->
        </div>
        <!-- en card -->

        <b-tabs
          class="mt-n5 pt-2"
          content-class="card card-body mt-3"
          nav-class="nav-tabs-custom"
          nav-wrapper-class="nav-tabs-custom"
        >
          <b-tab title="Overview" active>
            <div class="row">
              <div class="col-xl-3 col-sm-6">
                <div class="card border shadow-none">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar-sm">
                          <div
                            class="
                              avatar-title
                              bg-light
                              text-secondary
                              rounded-circle
                              font-size-18
                            "
                          >
                            <i class="bx bx-gas-pump"></i>
                          </div>
                        </div>
                      </div>

                      <div class="flex-grow-1 overflow-hidden">
                        <p class="mb-1 text-truncate text-muted">Total Load</p>
                        <h5 class="font-size-16 mb-0">5,000.00</h5>
                      </div>
                    </div>
                  </div>
                  <!-- end card body -->
                </div>
                <!-- end card -->
              </div>
              <!-- end col -->
              <div class="col-xl-3 col-sm-6">
                <div class="card border shadow-none">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar-sm">
                          <div
                            class="
                              avatar-title
                              bg-light
                              text-secondary
                              rounded-circle
                              font-size-18
                            "
                          >
                            <i class="uil uil-store-alt"></i>
                          </div>
                        </div>
                      </div>

                      <div class="flex-grow-1 overflow-hidden">
                        <p class="mb-1 text-truncate text-muted">
                          Total Provider Shared
                        </p>
                        <h5 class="font-size-16 mb-0">
                          2,200.00 <span class="small fw-normal">(21%)</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <!-- end card body -->
                </div>
                <!-- end card -->
              </div>
              <!-- end col -->
              <div class="col-xl-3 col-sm-6">
                <div class="card border shadow-none">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar-sm">
                          <div
                            class="
                              avatar-title
                              bg-light
                              text-secondary
                              rounded-circle
                              font-size-18
                            "
                          >
                            <i class="uil uil-users-alt"></i>
                          </div>
                        </div>
                      </div>

                      <div class="flex-grow-1 overflow-hidden">
                        <p class="mb-1 text-truncate text-muted">
                          Total User Share
                        </p>
                        <h5 class="font-size-16 mb-0">
                          1,000.00 <span class="small fw-normal">(11%)</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <!-- end card body -->
                </div>
                <!-- end card -->
              </div>
              <!-- end col -->
              <div class="col-xl-3 col-sm-6">
                <div class="card border shadow-none">
                  <div class="card-body">
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0 me-3">
                        <div class="avatar-sm">
                          <div
                            class="
                              avatar-title
                              bg-light
                              text-secondary
                              rounded-circle
                              font-size-18
                            "
                          >
                            <i class="uil uil-building"></i>
                          </div>
                        </div>
                      </div>

                      <div class="flex-grow-1 overflow-hidden">
                        <p class="mb-1 text-truncate text-muted">
                          Total Peddlr Share
                        </p>
                        <h5 class="font-size-16 mb-0">
                          1,200.00 <span class="small fw-normal">(10%)</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                  <!-- end card body-->
                </div>
                <!-- end card -->
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
            <div class="row mt-3">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    Profit Sharing List
                    <span class="text-muted fw-normal ms-2"
                      >({{ totalRows }})</span
                    >
                  </h5>
                </div>
              </div>

              <div class="col-md-6">
                <div
                  class="
                    d-flex
                    flex-wrap
                    align-items-start
                    justify-content-md-end
                    mt-2 mt-md-0
                    gap-2
                    mb-3
                  "
                >
                  <b-button v-if="profitSharingModule.access.create"
                    class="text-small"
                    variant="primary"
                    @click="$bvModal.show('bv-modal-add-provider-view')"
                    ><i class="uil uil-plus me-1"></i>ADD PROVIDERS</b-button
                  >
                </div>
              </div>
            </div>
            <!-- end row -->

            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="dataList"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="table-check"
                >
                  <template #cell(action)="data">
                    <div class="d-flex">
                      <div class="btn-group me-2 mb-2 mb-sm-0">
                        <b-button 
                          :disabled="!profitSharingModule.access.read && !profitSharingModule.access.update"
                          class="text-small"
                          variant="secondary"
                          size="sm"
                          @click="
                            $bvModal.show('bv-modal-provider-view');
                            infoModalFunction(data.index);
                          "
                          >SHOW INFO</b-button
                        >
                        <b-button
                          :disabled="!profitSharingModule.access.update"
                          class="btn-primary text-small"
                          variant="primary"
                          size="sm"
                          @click="
                            $bvModal.show('bv-modal-edit-provider-view');
                            infoModalFunction(data.index);
                          "
                          ><i class="bx bx-edit bx-xs bx-fw"></i
                        ></b-button>
                      </div>
                    </div>
                  </template>

                  <template #cell(provider)="data">
                    <p class="text-body m-0">
                      {{ data.item.provider }}
                    </p>
                  </template>

                  <template #cell(amount)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ data.item.amount.toFixed(2) }}
                    </p>
                  </template>

                  <template #cell(provider_shared)="data">
                    <p class="text-body text-end m-0">
                      {{ data.item.provider_shared.toFixed(1) }}%
                    </p>
                  </template>

                  <template #cell(customer_share)="data">
                    <p class="text-body text-end m-0">
                      {{ data.item.customer_share.toFixed(1) }}%
                    </p>
                  </template>

                  <template #cell(peddlr_share)="data">
                    <p class="text-body text-end m-0">
                      {{ data.item.peddlr_share.toFixed(1) }}%
                    </p>
                  </template>

                  <template #cell(date)="data">
                    <p class="text-body m-0">
                      {{ data.item.created_at | formatDate }}
                    </p>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->

            <!-- show provider info modal -->
            <b-modal
              id="bv-modal-provider-view"
              centered
              title="Provider Information"
              @hidden="actionIndex = -1"
              hide-footer
              no-close-on-esc
              no-close-on-backdrop
            >
              <div class="mx-4 my-2">
                <p class="small mb-2">{{ view.date | formatDate }}</p>
                <p class="fw-bold mb-2">
                  Provider Name:
                  <span class="fw-medium">{{ view.providerName }}</span>
                </p>
                <!-- <p class="fw-bold mb-2">Wallet: <span class="fw-medium">E-Load</span></p> -->
                <p class="fw-bold mb-2">
                  Amount: <span class="fw-medium">{{ view.amount }}</span>
                </p>
                <p class="fw-bold mb-2">
                  Provider Shared:
                  <span class="fw-medium">{{ view.providerShared }}%</span>
                </p>

                <div class="d-flex">
                  <div class="mb-3">
                    <label
                      for="disabledTextInput"
                      class="form-label small fw-bold"
                      >User Share:</label
                    >
                    <div class="input-group input-group-sm">
                      <input
                        type="text"
                        id="disabledTextInput"
                        class="form-control rounded-2"
                        :value="view.userShare"
                        disabled
                      />
                      <div
                        class="
                          input-group-text
                          mx-1
                          bg-white
                          border-0
                          rounded-0
                          fw-bold
                        "
                      >
                        +
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label
                      for="disabledTextInput"
                      class="form-label small fw-bold"
                      >Peddlr Share:</label
                    >
                    <div class="input-group input-group-sm">
                      <input
                        type="text"
                        id="disabledTextInput"
                        class="form-control rounded-2"
                        :value="view.peddlrShare"
                        disabled
                      />
                      <div
                        class="
                          input-group-text
                          mx-1
                          bg-white
                          border-0
                          rounded-0
                          fw-bold
                        "
                      >
                        =
                      </div>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label
                      for="disabledTextInput"
                      class="form-label small fw-bold"
                      >Total:</label
                    >
                    <input
                      type="text"
                      id="disabledTextInput"
                      class="form-control form-control-sm"
                      :value="view.providerShared"
                      disabled
                    />
                  </div>
                </div>

                <!-- <div class="col text-end"><b-button class="btn px-5 mt-2" variant="secondary" @click="$bvModal.hide('bv-modal-provider-view'); actionIndex = -1">Ok</b-button></div> -->
              </div>
            </b-modal>

            <!-- show provider edit modal -->
            <b-modal
              id="bv-modal-edit-provider-view"
              centered
              title="Edit Provider Information"
              hide-footer
              hide-header-close
              no-close-on-esc
              no-close-on-backdrop
            >
              <div class="mx-4 my-2">
                <p class="small mb-2">{{ view.date }}</p>
                <p class="fw-bold mb-2">
                  Provider Name:
                  <span class="fw-medium">{{ view.providerName }}</span>
                </p>
                <!-- <p class="fw-bold mb-2">Wallet: <span class="fw-medium">E-Load</span></p> -->
                <p class="fw-bold mb-2">
                  Amount: <span class="fw-medium">{{ view.amount }}</span>
                </p>
                <p class="fw-bold mb-2">
                  Provider Shared:
                  <span class="fw-medium">{{ view.providerShared }}%</span>
                </p>

                <div class="d-flex">
                  <div>
                    <label for="disabledTextInput" class="form-label small fw-bold">User Share:</label>
                    <div class="input-group input-group-sm">
                        <!-- <input type="text" id="disabledTextInput" class="form-control rounded-2"  @input="event => totalShare(event)" :class="{'is-invalid': parseFloat(this.creationParams.totalShare) > parseFloat(this.creationParams.providerShared) && submit}" v-model="creationParams.userShare"> -->
                        <input
                          v-model="updateParams.userShare"
                          type="text"
                          class="form-control rounded-2"
                          placeholder="0.0%"
                          name="userShare"
                          id="disabledTextInput"
                          :class="{
                            'is-invalid': updateSubmit && $v.updateParams.userShare.$error,
                          }"
                        />
                        <div class="input-group-text mx-1 bg-white border-0 rounded-0 fw-bold">+</div>
                        <div v-if="updateSubmit && $v.updateParams.userShare.$error"
                          class="text-danger">
                          <span v-if="!$v.updateParams.userShare.required">This value is required.</span>
                        </div>
                    </div>
                  </div>

                  <div>
                    <label for="disabledTextInput" class="form-label small fw-bold">Peddlr Share:</label>
                    <div class="input-group input-group-sm">
                        <!-- <input type="text" id="disabledTextInput" @input="event => totalShare(event)" class="form-control rounded-2" :class="{'is-invalid': parseFloat(this.creationParams.totalShare) > parseFloat(this.creationParams.providerShared) && submit}" v-model="creationParams.peddlrShare"> -->
                        <input
                          v-model="updateParams.peddlrShare"
                          type="text"
                          class="form-control rounded-2"
                          placeholder="0.0%"
                          name="peddlrShare"
                          id="disabledTextInput"
                          :class="{
                            'is-invalid': updateSubmit && $v.updateParams.peddlrShare.$error,
                          }"
                        />
                        <div class="input-group-text mx-1 bg-white border-0 rounded-0 fw-bold">=</div>
                        <div v-if="updateSubmit && $v.updateParams.peddlrShare.$error"
                          class="text-danger">
                          <span v-if="!$v.updateParams.peddlrShare.required"
                            >This value is required.</span>
                        </div>
                    </div>
                  </div>

                  <div>
                    <label for="disabledTextInput" class="form-label small fw-bold">Total:</label>
                    <input type="text" id="disabledTextInput" class="form-control form-control-sm" :value="totalShareValidatorU" disabled>
                  </div>

                </div>
                <div v-if="updateSubmit && (!$v.updateParams.userShare.totalShareValidatorU || !$v.updateParams.peddlrShare.totalShareValidatorU)" class="text-danger mb-3">
                  <span >The total share should be equal to provider shared.</span>
                </div>

                <div class="d-flex justify-content-end">
                  <b-button
                    class="btn px-5 mt-2 me-2"
                    variant="light"
                    @click="
                      $bvModal.hide('bv-modal-edit-provider-view');
                      actionIndex = -1;
                      onCloseModal();
                    "
                    >Cancel</b-button
                  >
                  <b-button
                    class="btn px-5 mt-2"
                    variant="primary"
                    @click="
                      actionIndex = -1;
                      update();
                    "
                    >Save</b-button
                  >
                </div>
              </div>
            </b-modal>

            <!-- show add provider modal -->
            <b-modal
              id="bv-modal-add-provider-view"
              centered
              title="Add Provider Information"
              hide-footer
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
            >
              <div class="mx-4 my-2">
                <form @submit.prevent="create()">
                  <div class="mb-3">
                    <label class="form-label mb-1">Provider Name:</label>
                    <input
                      v-model="creationParams.providerName"
                      type="text"
                      class="form-control"
                      placeholder="Provider Name"
                      name="providerName"
                      @input="$v.creationParams.providerName.$touch()"
                      :class="{
                        'is-invalid': submit && $v.creationParams.providerName.$error,
                      }"
                    />
                    <div v-if="submit && $v.creationParams.providerName.$error"
                      class="text-danger">
                      <span v-if="!$v.creationParams.providerName.required"
                        >This value is required.</span>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="providerWallet" class="form-label mb-1"
                      >Amount:</label
                    >
                    <input
                      v-model="creationParams.amount"
                      type="text"
                      class="form-control"
                      placeholder="0.00"
                      name="amount"
                      :class="{
                        'is-invalid': submit && $v.creationParams.amount.$error,
                      }"
                    />
                    <div v-if="submit && $v.creationParams.amount.$error"
                      class="text-danger">
                      <span v-if="!$v.creationParams.amount.required"
                        >This value is required.</span>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label for="providerWallet" class="form-label mb-1"
                      >Provider Shared:</label
                    >
                    <input
                      v-model="creationParams.providerShared"
                      type="text"
                      class="form-control"
                      placeholder="0.0%"
                      name="providerShared"
                      :class="{
                        'is-invalid': submit && $v.creationParams.providerShared.$error,
                      }"
                    />
                    <div v-if="submit && $v.creationParams.providerShared.$error"
                      class="text-danger">
                      <span v-if="!$v.creationParams.providerShared.required"
                        >This value is required.</span>
                    </div>
                  </div>


                  <div class="d-flex">
                    <div>
                      <label for="disabledTextInput" class="form-label small fw-bold">User Share:</label>
                      <div class="input-group input-group-sm">
                          <!-- <input type="text" id="disabledTextInput" class="form-control rounded-2"  @input="event => totalShare(event)" :class="{'is-invalid': parseFloat(this.creationParams.totalShare) > parseFloat(this.creationParams.providerShared) && submit}" v-model="creationParams.userShare"> -->
                          <input
                            v-model="creationParams.userShare"
                            type="text"
                            class="form-control rounded-2"
                            placeholder="0.0%"
                            name="userShare"
                            id="disabledTextInput"
                            :class="{
                              'is-invalid': submit && $v.creationParams.userShare.$error,
                            }"
                          />
                          <div class="input-group-text mx-1 bg-white border-0 rounded-0 fw-bold">+</div>
                          <div v-if="submit && $v.creationParams.userShare.$error"
                            class="text-danger">
                            <span v-if="!$v.creationParams.userShare.required">This value is required.</span>
                          </div>
                      </div>
                    </div>

                    <div>
                      <label for="disabledTextInput" class="form-label small fw-bold">Peddlr Share:</label>
                      <div class="input-group input-group-sm">
                          <!-- <input type="text" id="disabledTextInput" @input="event => totalShare(event)" class="form-control rounded-2" :class="{'is-invalid': parseFloat(this.creationParams.totalShare) > parseFloat(this.creationParams.providerShared) && submit}" v-model="creationParams.peddlrShare"> -->
                          <input
                            v-model="creationParams.peddlrShare"
                            type="text"
                            class="form-control rounded-2"
                            placeholder="0.0%"
                            name="peddlrShare"
                            id="disabledTextInput"
                            :class="{
                              'is-invalid': submit && $v.creationParams.userShare.$error,
                            }"
                          />
                          <div class="input-group-text mx-1 bg-white border-0 rounded-0 fw-bold">=</div>
                          <div v-if="submit && $v.creationParams.peddlrShare.$error"
                            class="text-danger">
                            <span v-if="!$v.creationParams.peddlrShare.required"
                              >This value is required.</span>
                          </div>
                      </div>
                    </div>

                    <div>
                      <label for="disabledTextInput" class="form-label small fw-bold">Total:</label>
                      <input type="text" id="disabledTextInput" class="form-control form-control-sm" :value="totalShareValidatorC" disabled>
                    </div>

                  </div>
                    <div v-if="submit && (!$v.creationParams.userShare.totalShareValidatorC || !$v.creationParams.peddlrShare.totalShareValidatorC)" class="text-danger mb-3">
                      <span >The total share should be equal to provider shared.</span>
                    </div>
                  <div class="d-flex justify-content-end">
                    <b-button
                      class="btn px-5 mt-2 me-2"
                      variant="light"
                      @click="
                        $bvModal.hide('bv-modal-add-provider-view');
                        actionIndex = -1;
                        onCloseModal();
                      "
                      >Cancel</b-button
                    >
                    <b-button
                      class="btn px-5 mt-2"
                      type="submit"
                      variant="primary"
                      >Submit</b-button
                    >
                  </div>
                </form>
              </div>
            </b-modal>

            <!-- pagination -->
            <div class="row g-0 text-center text-sm-start">
              <div class="col-sm-6">
                <div class="">
                  <!-- <p class="mb-sm-0">Showing 1 to 6 of 12 entries</p> -->
                </div>
              </div>
              <!-- end col -->
              <div class="col-sm-6 text-lg-end text-sm-center">
                <div class="row">
                  <div
                    class="d-flex justify-content-center justify-content-lg-end"
                  >
                    <div class="dataTables_paginate paging_simple_numbers">
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        @input="onNextPage()"
                        :total-rows="totalRows"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end pagination -->
          </b-tab>
        </b-tabs>
        <!-- Nav tabs -->
      </div>
      <!-- end col -->
    </div>
  </div>
</template>
